import { Platform } from 'quasar';
import { boot } from 'quasar/wrappers';
import { AppTrackingTransparency } from 'src/../src-capacitor/node_modules/capacitor-plugin-app-tracking-transparency';

export enum APP_TRACKING_STATUSES {
  NOT_DETERMINED = 'notDetermined',
}

export default boot(async ({}) => {
  if (!Platform.is.ios) return;

  let res = await AppTrackingTransparency.getStatus();

  while (res.status === APP_TRACKING_STATUSES.NOT_DETERMINED) {
    await AppTrackingTransparency.requestPermission();
    res = await AppTrackingTransparency.getStatus();
  }
});
